module.exports = __webpack_public_path__ + "img/owenb.f28ff838.jpg";